import React, { useState, forwardRef, useEffect, useMemo } from 'react'
import styles from './style.module.scss'
import { s18n } from '../../../i18n'
import { isMobile } from 'react-device-detect'
import ConditionalRender from '../../../utils/conditionalRender'
import XDropdown from '../XDropdown'
import { FormProvider, useForm } from 'react-hook-form'

interface Props {}

const XLanguageSwitcher = forwardRef<HTMLSelectElement, Props>((props: Props, ref) => {
    const [languages, setLanguages] = useState(window.LANGUAGES)
    const form = useForm()

    const [selectedLanguage, setSelectedLanguage] = useState<{ code: string; text: string }>(
        window.LANGUAGES.find((l) => l.code === s18n.language) || window.LANGUAGES.find((l) => l.code === 'en')
    )

    const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedCode = event.target.value
        const selectedText = event.target.options[event.target.selectedIndex].text
        setSelectedLanguage({ code: selectedCode, text: selectedText })
    }

    useEffect(() => {
        void s18n.changeLanguage(selectedLanguage?.code)
    }, [selectedLanguage])

    useEffect(() => {
        if (!isMobile) {
            const language = window?.LANGUAGES?.find((l) => l.text === form.getValues(id))
            setSelectedLanguage(language)
        }
    }, [form])

    const id = useMemo(() => {
        return 'languageDropdownFooter'
    }, [])

    return (
        <>
            {languages.length > 1 && (
                <div className={styles.xLanguageSwitcher__container}>
                    <ConditionalRender if={!isMobile}>
                        <FormProvider {...form}>
                            <XDropdown
                                noMargin={true}
                                footer={true}
                                dropdownData={window.LANGUAGES.map((l) => l.text)}
                                label={''}
                                defaultValue={selectedLanguage?.text}
                                id={id}
                                name={id}
                            />
                        </FormProvider>
                    </ConditionalRender>

                    <ConditionalRender if={isMobile}>
                        <select
                            id={id}
                            name={id}
                            className={styles.xLanguageSwitcher__select}
                            value={selectedLanguage?.code}
                            onChange={handleLanguageChange}
                            ref={ref}
                        >
                            {languages?.map((language) => (
                                <option key={language.code} value={language.code}>
                                    {language.text}
                                </option>
                            ))}
                        </select>
                    </ConditionalRender>
                </div>
            )}
        </>
    )
})

XLanguageSwitcher.displayName = 'XLanguageSwitcher'

export default XLanguageSwitcher
